/**
 * Utility for uploading canvas images to CDN.
 * Handles both Picsart-hosted and local/external URLs.
 */

import { uploadToCDN } from '@/requests/cloud-storage';

const PICSART_DOMAINS = ['picsart.com', 'cdn.picsart', 'cdnmf.picsart'];

/**
 * Check if URL is already hosted on Picsart servers
 */
export const isPicsartUrl = (url: string): boolean =>
  PICSART_DOMAINS.some((domain) => url.includes(domain));

type UploadCanvasImageParams = {
  url: string;
  imageId: string;
};

/**
 * Upload a canvas image URL to CDN.
 * If already on Picsart servers, returns the URL directly.
 * Otherwise fetches and uploads to CDN.
 */
export const uploadCanvasImage = async ({
  url,
  imageId,
}: UploadCanvasImageParams): Promise<string> => {
  if (isPicsartUrl(url)) {
    return url;
  }

  const response = await fetch(url);
  const blob = await response.blob();
  const file = new File([blob], `canvas-${imageId}.png`, { type: 'image/png' });
  return uploadToCDN(file);
};
